"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAdminFeatureFlagSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const get_1 = require("./get.js");
exports.updateAdminFeatureFlagSlice = (0, xuder_1.createUpdateSyncSlice)({
    name: name_1.AdminFeatureFlagsName,
    state: get_1.getAdminFeatureFlagsSlice.asyncState,
    transform: (action, state = {
        featureFlags: [],
        totalCustomerCount: 0
    }) => {
        var _a, _b, _c, _d;
        const index = state.featureFlags.findIndex((flag) => flag.name === action.id);
        if (index === -1) {
            return state;
        }
        const target = state.featureFlags[index];
        if (!target) {
            return state;
        }
        return {
            featureFlags: [
                ...state.featureFlags.slice(0, index),
                Object.assign(Object.assign({}, target), { enabledByDefault: (_a = action.defaultValue) !== null && _a !== void 0 ? _a : target.enabledByDefault, groupId: (_b = action.groupId) !== null && _b !== void 0 ? _b : target.groupId, groupName: (_c = action.groupName) !== null && _c !== void 0 ? _c : target.groupName, state: (_d = action.forcedValue) !== null && _d !== void 0 ? _d : target.state }),
                ...state.featureFlags.slice(index + 1)
            ],
            totalCustomerCount: state.totalCustomerCount
        };
    }
});
//# sourceMappingURL=update.js.map